import { WithPagination } from '@shared/types'

export type MFAConfig = {
  enabled: boolean
  email_enabled: boolean
  preferred_method: MFAPreferredMethods
  backup_codes: string[]
}

export enum MFAPreferredMethods {
  EMAIL = 'email'
}

export type EditMFAConfig = Partial<Omit<MFAConfig, 'backup_codes'>>

export type MFAConfigGenerateBackupCodes = Pick<MFAConfig, 'backup_codes'>

export type WithCustomMFAToken = { __mfaAccessToken: string }

export enum MFAPurpose {
  LOGIN = 'login',
  CHANGE_PASSWORD = 'change_password'
}

export type MFASendOTP = {
  channel?: MFAPreferredMethods
  service_token?: string
  purpose?: MFAPurpose
} & WithCustomMFAToken

export type MFAResponseSendOTP = {
  sent: boolean
  channel: MFAPreferredMethods
  masked_destination: string
  expires_in: string
  wait: string
}

export type MFAVerifyOTP = {
  opt_code: string
  trusted_device?: boolean
  device_name?: string
} & WithCustomMFAToken

export type MFAResponseVerifyOTP = {
  access: string
  refresh: string
  device_token: string
  change_password_access_token?: string
}

export type MFAVerifyBackupCode = {
  backup_code: string
} & WithCustomMFAToken

export type MFAResponseVerifyBackupCode = Omit<
  MFAResponseVerifyOTP,
  'device_token'
>

export type MFATrustedDevice = {
  id: string
  created_at: string
  last_used: string
  user_agent: string
  ip_address: string
  device_name?: string
}

export type WithPaginationMFATrustedDevice = WithPagination<MFATrustedDevice>

export type MFATrustedDeviceParams = {
  page?: number
  page_size?: number
}
